export default "__VITE_ASSET__CBD457Qz__"